import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { NotificationsSettings } from '@widgets/settings/components';

export const Route = createFileRoute('/profile/settings/notifications')({
  component: Component,
});

export default function Component() {
  useTelegramBackButton({ to: 'back' });

  return (
    <>
      <Page style={{ padding: '8px 0' }}>
        <NotificationsSettings />
      </Page>
    </>
  );
}
